
import {computed, defineComponent, ref} from "vue";
import FilterSlide from "./FilterSlide.vue";
import FilterCheck from "./FilterCheck.vue";

export default defineComponent({
    name: "FilterSection",
    components: {
        FilterSlide,
        FilterCheck
    },
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const controlType = props.section.type === 'slide' ? FilterSlide : FilterCheck
        const filter = ref("")

        const collection = computed(() => {
            return props.section.data
                .filter((one: any) => one.label && one.label.toLowerCase().includes(filter.value.toLowerCase()))
                .sort((one: any, two: any) => one.label > two.label ? 1 : -1)
        })

        const basicCountToRender = 5

        const isCollapsed = ref(true)
        const toggleCollapse = () => isCollapsed.value = !isCollapsed.value

        const collectionToRender = computed(() => {
            return collection.value
                .slice(0, allVisible.value ? collection.value.length : basicCountToRender)
        })

        const allVisible = ref(false)
        const toggleVisibility = () => allVisible.value = !allVisible.value

        const selectedCount = computed(() => {
            if (props.section.type === 'slide') {
                return 0
            }
            return props.section.data.filter((one: any) => one.checked).length
        })

        return {
            controlType,
            filter,
            collection,
            collectionToRender,
            allVisible,
            toggleVisibility,
            isCollapsed,
            toggleCollapse,
            basicCountToRender,
            selectedCount
        }
    }
});
